import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { PriceFormScheme } from "../../../components/Forms/SummaryForm/components/validation.ts";
import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useUpdateBookingPrice = (id: string) => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: PriceFormScheme) => {
      const response = fetch(`${Urls.BookingPrice}?newPrice=${data.newPrice}&changeReason=${data.changeReason}`, {
        method: "PUT",
        body: JSON.stringify({
          ...data,
          newPrice: Number(data.newPrice),
        }),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
        slug: {
          bookingId: id,
        },
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["booking-id", id] });
      await queryClient.invalidateQueries({ queryKey: ["price-history", id] });
      toast.success("Ціну успішно змінено");
    },
    onError: (error) => {
      toast.error(error?.message || "Error updating booking price");
    },
  });
};
